import React from 'react';

import styled from 'styled-components';

import { BackArrowLink } from 'components/navigation/back-arrow';

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  position: fixed;
  top: calc(3px + env(safe-area-inset-top));
  left: 3px;
  z-index: ${Styles.zIndex.overlay};
  margin: 1rem;
`;

interface IMobileBackButton {
  onClick?: () => void;
  to: string;
}
export const MobileBackButton: React.FC<IMobileBackButton> = ({ to }) => {
  return (
    <Container>
      <BackArrowLink to={to} />
    </Container>
  );
};
